import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function PrivacyPolicy() {
    return (
        <section className="min-h-screen bg-appBg dark:bg-appDark py-4 px-6">

            <div className="max-w-6xl mx-auto">

                {/* TITLE */}
                <h1 className="text-4xl font-bold mb-8 text-titleLight dark:text-titleDark">
                    Privacy Policy
                </h1>

                {/* DATE */}
                <p className="mb-6 text-subText dark:text-subTextDark">
                    Last updated: March 2026
                </p>

                {/* CONTENT BOX */}
                <div className="bg-card dark:bg-cardDark border border-borderLight dark:border-borderDark rounded-2xl p-6 md:p-8 space-y-6 text-textMain dark:text-textDark leading-relaxed">

                    <p>
                        At ClickBoard, your privacy is our priority. This policy explains how we collect, use, and protect your information when you use our website, ensuring a safe and secure experience for all users.
                    </p>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            1. Information We Do Not Collect
                        </h2>

                        <p>
                            We do not require you to create an account or provide personal details like your name, email, or phone number.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            2. Information You Provide
                        </h2>

                        <p>
                            When you use ClickBoard, any text you enter to transfer between devices is temporarily stored to make the service work.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            3. How We Use Your Data
                        </h2>

                        <p>
                            Your data is used only to generate a unique code and let you retrieve your text on another device. We do not use your information for tracking, advertising, or analytics.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            4. Data Storage and Expiry
                        </h2>

                        <ul className="list-disc ml-6 space-y-2">
                            <li>Your data is stored temporarily on secure servers.</li>
                            <li>It is automatically deleted after a short time.</li>
                            <li>If you use the one-time access feature, data is deleted immediately after it’s viewed.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            5. Data Security
                        </h2>

                        <p>
                            We follow industry-standard security measures to protect your data. However, we advise against sharing highly sensitive or confidential information through our service.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            6. Third-Party Services
                        </h2>

                        <p>
                            We may use trusted third-party services like Firebase for secure data storage and management. These providers have their own privacy policies and security practices.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            7. Cookies
                        </h2>

                        <p>
                            ClickBoard uses basic cookies to improve your experience, such as remembering preferences and enhancing performance.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            8. Changes to This Policy
                        </h2>

                        <p>
                            We may update this Privacy Policy occasionally. Any changes will be posted on this page with an updated revision date.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            9. Contact Us
                        </h2>

                        <p className="mb-2">
                            If you have questions, feedback, or need assistance, please reach out to us via our contact page.
                        </p>

                        <Link
                            to="/contact"
                            className="text-primary hover:underline font-medium"
                        >
                            Go to Contact Page
                        </Link>
                    </div>

                </div>

                {/* BACK BUTTON */}
                <div className="mt-16">
                    <Link
                        to="/"
                        className="bg-primary hover:bg-primaryHover text-whiteCustom px-6 py-3 rounded-md transition"
                    >
                        ← Back to Home
                    </Link>
                </div>

                <Footer />

            </div>

        </section>
    );
}